// Campos internos/infraestrutura que não devem ser exibidos como opções selecionáveis pelo usuário
export const INTERNAL_FIELD_IDS = ['id', 'exchangeRate', 'currency', 'ticker']

export const filterPublicFields = (fields) =>
	fields.filter(f => !INTERNAL_FIELD_IDS.includes(f.id))
